import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "rounded-xl bg-white/5 p-2 text-zinc-400 transition-colors hover:bg-white/10 hover:text-white disabled:opacity-50 w-[36px] h-[36px] border-2 border-zinc-400" }
const _hoisted_4 = {
  key: 2,
  class: "rounded-xl bg-white/5 p-2 text-zinc-400 transition-colors hover:bg-white/10 hover:text-white disabled:opacity-50 w-[36px] h-[36px]"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "flex items-center gap-4"
}

import {
  ChevronDoubleLeftIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronDoubleRightIcon,
} from '@heroicons/vue/24/outline'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { PaginationData } from '@/interfaces/Pagination'
import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
    perPage: {},
    data: {},
    class: {}
  },
  emits: ["update:per-page", "update:page"],
  setup(__props: any, { emit: __emit }) {

const paginationIcons = [
  ChevronDoubleLeftIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronDoubleRightIcon,
]

const props = __props
const emit = __emit

const selectedPerPage = computed({
  get: () => props.perPage,
  set: (value: string) => emit('update:per-page', value),
})

const displayNextToLast = computed(() => 
  !!(props.data!.lastPage - 1) && 
  (props.data!.lastPage - 1) !== props.data!.nextPage && 
  (props.data!.lastPage - 1) !== props.data!.currentPage && 
  (props.data!.lastPage - 1) !== props.data!.prevPage
)

const displayLastPage = computed(() => 
  props.data!.lastPage !== props.data!.nextPage && 
  props.data!.lastPage !== props.data!.currentPage
)

const paginate = (page: any) => {
  emit('update:page', page)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.class, "mt-6 flex flex-wrap gap-4 items-center justify-between"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.data)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (paginate(_ctx.data.prevPage!))),
              disabled: !_ctx.data.prevPage,
              class: "rounded-xl bg-white/5 p-2 text-zinc-400 transition-colors hover:bg-white/10 hover:text-white disabled:opacity-50"
            }, [
              _createVNode(_unref(ChevronLeftIcon), { class: "h-5 w-5" })
            ], 8, _hoisted_2),
            (_ctx.data.total)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.data.prevPage !== 1 && _ctx.data.currentPage !== 1)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        value: 1,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (paginate(1))),
                        class: "rounded-xl bg-white/5 p-2 text-zinc-400 transition-colors hover:bg-white/10 hover:text-white disabled:opacity-50 w-[36px] h-[36px]"
                      }, " 1 "))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", _hoisted_3, _toDisplayString(_ctx.data.currentPage), 1),
                  (_ctx.data.nextPage)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (paginate(_ctx.data.nextPage!))),
                        class: "rounded-xl bg-white/5 p-2 text-zinc-400 transition-colors hover:bg-white/10 hover:text-white disabled:opacity-50 w-[36px] h-[36px]"
                      }, _toDisplayString(_ctx.data.nextPage), 1))
                    : _createCommentVNode("", true),
                  (displayLastPage.value)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_4, " ... "))
                    : _createCommentVNode("", true),
                  (displayNextToLast.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (paginate(_ctx.data.lastPage - 1))),
                        class: "rounded-xl bg-white/5 p-2 text-zinc-400 transition-colors hover:bg-white/10 hover:text-white disabled:opacity-50 w-[36px] h-[36px]"
                      }, _toDisplayString((_ctx.data.lastPage - 1)), 1))
                    : _createCommentVNode("", true),
                  (displayLastPage.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 4,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (paginate(_ctx.data.lastPage))),
                        class: "rounded-xl bg-white/5 p-2 text-zinc-400 transition-colors hover:bg-white/10 hover:text-white disabled:opacity-50 w-[36px] h-[36px]"
                      }, _toDisplayString(_ctx.data.lastPage), 1))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (paginate(_ctx.data.nextPage!))),
              disabled: !_ctx.data.nextPage,
              class: "rounded-xl bg-white/5 p-2 text-zinc-400 transition-colors hover:bg-white/10 hover:text-white disabled:opacity-50"
            }, [
              _createVNode(_unref(ChevronRightIcon), { class: "h-5 w-5" })
            ], 8, _hoisted_5)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (selectedPerPage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_unref(Select), {
            modelValue: selectedPerPage.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedPerPage).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(SelectTrigger), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(SelectValue), {
                    placeholder: `${selectedPerPage.value} por página`
                  }, null, 8, ["placeholder"])
                ]),
                _: 1
              }),
              _createVNode(_unref(SelectContent), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(SelectItem), { value: "10" }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("10 por página")
                    ])),
                    _: 1
                  }),
                  _createVNode(_unref(SelectItem), { value: "25" }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode("25 por página")
                    ])),
                    _: 1
                  }),
                  _createVNode(_unref(SelectItem), { value: "50" }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("50 por página")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-sm text-zinc-400 w-[142px]" }, " Página 1 de 1 ", -1))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})